import React, { useEffect, useRef } from "react";

// Renders an admin-provided forms.app share LINK (as an iframe) OR raw embed HTML
// (executing any <script> tags). Detects a plain URL vs HTML markup.
export default function HtmlEmbed({ html }) {
  const ref = useRef(null);
  const val = (html || "").trim();
  const isUrl = val && !val.includes("<") && /^https?:\/\//i.test(val);

  useEffect(() => {
    if (isUrl) return;
    const el = ref.current;
    if (!el) return;
    el.innerHTML = val;
    el.querySelectorAll("script").forEach((old) => {
      const s = document.createElement("script");
      [...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
      s.text = old.text;
      old.replaceWith(s);
    });
  }, [val, isUrl]);

  if (isUrl) {
    return (
      <iframe
        title="Form"
        src={val}
        data-testid="embed-iframe"
        className="w-full rounded-xl border border-zinc-200 bg-white"
        style={{ minHeight: 780 }}
        allow="clipboard-write"
      />
    );
  }
  return <div ref={ref} data-testid="html-embed" />;
}
